// assets/src/jsx/components/Home/Hero.jsx
import React from 'react';
import {NavLink} from 'react-router-dom';
import IntlMessages from 'appUtil/IntlMessages';
import ImportDatabaseButton from 'components/Home/ImportDatabaseButton';
import heroImage from '../../../png/hero-bg.png';

const Hero = ({titleId, subtitleId}) => (
    <div className="gdb-home-hero">
        <div className="gdb-home-hero__text">
            <h1 className="gdb-home-hero__title"><IntlMessages id={titleId}/></h1>
            <p className="gdb-home-hero__subtitle"><IntlMessages id={subtitleId}/></p>
            <div className="gdb-home-hero__actions">
                <NavLink className="system-button size-m" to="/app/database/create">
                    <i className="far fa-plus" aria-hidden="true"/><IntlMessages id="home.cta.create"/>
                </NavLink>
                <ImportDatabaseButton/>
            </div>
        </div>
        <div className="gdb-home-hero__art">
            <img src={heroImage} alt="" decoding="async"/>
        </div>
    </div>
);

export default Hero;
